
export const UPDATE_APP = 'app_UPDATE';
export const updateApp = data => ({
  type: UPDATE_APP,
  payload: data,
})

export const APP_LOADED = 'app/APP_LOADED';
export const appLoaded = () => ({
  type: APP_LOADED,
});

export const BEFORE_UNLOAD = 'app/BEFORE_UNLOAD';
export const beforeUnload = () => ({
  type: BEFORE_UNLOAD,
});
